var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.149,
    height: 22.149,
    viewBox: "0 0 22.149 22.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160467",
    "data-name": "Group 160467",
    transform: "translate(-26.296 -89.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M15.871-50.047V-29.9",
    transform: "translate(17 140.633)",
    fill: "none",
    stroke: "#131385",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160466",
    "data-name": "Group 160466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M15.871-50.047V-29.9",
    transform: "translate(26 140.633)",
    fill: "none",
    stroke: "#131385",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M15.871-50.047V-29.9",
    transform: "translate(-2.602 89.289) rotate(90)",
    fill: "none",
    stroke: "#131385",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M15.871-50.047V-29.9",
    transform: "translate(-2.602 80.289) rotate(90)",
    fill: "none",
    stroke: "#131385",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashIcon);
export default __webpack_public_path__ + "static/media/hash-icon.b4c4f0209a106f20c6ee65acf2eb0383.svg";
export { ForwardRef as ReactComponent };